module.exports = __webpack_public_path__ + "media/prescription-remind.9eeb44e2.mp3";